import { signal, computed, Injectable } from "@angular/core";
import type { FilterField, FilterSelections, FiltersByField } from "@filter/filter.types";

@Injectable()
export class FilterRegistry {
    private readonly filtersByField = signal<FiltersByField>(new Map());

    public readonly list = computed(() => Array.from(this.filtersByField().values()));

    public initialize(fields: readonly FilterField[], selections: FilterSelections | undefined): void {
        const filtersByField: FiltersByField = new Map();
        fields.forEach((field) => {
            const selection = selections?.[field.definition.filterName];
            field.setSelection(selection);
            filtersByField.set(field.definition.filterName, field);
        });
        this.filtersByField.set(filtersByField);
    }

    public get(fieldName: string): FilterField | undefined {
        return this.filtersByField().get(fieldName);
    }
}
